configurationEmailSmtpFormValidator.$inject = ['validator'];

export default function configurationEmailSmtpFormValidator(validator) {
	const instance = new validator();

	instance.ruleFor('idSociete').notEmpty().when(isRequired).withMessage('VALIDATION_NOTEMPTY');

	// Type 0 - SMTP
	instance.ruleFor('smtpLogin').notEmpty().when(isSmtp).withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('smtpLogin').emailAddress().when(isSmtp).withMessage('VALIDATION_EMAIL');
	instance
		.ruleFor('smtpPass')
		.notEmpty()
		.when((obj) => isSmtp(obj) && !obj.smtpPassFromServeur)
		.withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('smtpServer').notEmpty().when(isSmtp).withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('smtpPort').greaterThan(0).when(isSmtp).withMessage('VALIDATION_NOT_INTEGER_POSITIVE');
	instance
		.ruleFor('smtpAlias')
		.emailAddress()
		.when((obj, prop) => isSmtp(obj) && isCompleted(obj, prop))
		.withMessage('VALIDATION_EMAIL');

	// Type 1 - Microsoft
	instance.ruleFor('senderMail').notEmpty().when(isMicrosoft).withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('senderMail').emailAddress().when(isMicrosoft).withMessage('VALIDATION_EMAIL');
	instance
		.ruleFor('clientIdMS')
		.notEmpty()
		.when((obj) => isMicrosoft(obj) && !obj.clientIdMSFromServeur)
		.withMessage('VALIDATION_NOTEMPTY');
	instance
		.ruleFor('tenantIdMS')
		.notEmpty()
		.when((obj) => isMicrosoft(obj) && !obj.tenantIdMSFromServeur)
		.withMessage('VALIDATION_NOTEMPTY');
	instance
		.ruleFor('clientSecretMS')
		.notEmpty()
		.when((obj) => isMicrosoft(obj) && !obj.clientSecretMSFromServeur)
		.withMessage('VALIDATION_NOTEMPTY');

	// Type 2 - Google
	instance
		.ruleFor('clientIdGoogle')
		.notEmpty()
		.when((obj) => isGoogle(obj) && !obj.clientIdGoogleFromServeur)
		.withMessage('VALIDATION_NOTEMPTY');
	instance
		.ruleFor('clientSecretGoogle')
		.notEmpty()
		.when((obj) => isGoogle(obj) && !obj.clientSecretGoogleFromServeur)
		.withMessage('VALIDATION_NOTEMPTY');
	instance
		.ruleFor('refreshTokenGoogle')
		.notEmpty()
		.when((obj) => isGoogle(obj) && !obj.refreshTokenGoogleFromServeur)
		.withMessage('VALIDATION_NOTEMPTY');

	return instance;

	function isSmtp(obj) {
		return obj.type === 0;
	}

	function isMicrosoft(obj) {
		return obj.type === 1;
	}

	function isGoogle(obj) {
		return obj.type === 2;
	}

	function isCompleted(obj, prop) {
		return prop != null && typeof prop != 'undefined' && prop != '';
	}

	function isRequired(obj) {
		if (obj.id == null) {
			return true;
		}
	}
}
